<ng-template [ngIf]="src">

   <div class="video-container" [ngStyle]="{'width': width, 'height': height}">
      <div class="video-wrapper">
         <!-- Iframe -->
         <ng-template #iframe [ngIf]="src.includes('www.youtube.com/embed') || src.includes('player.vimeo.com')" [ngIfElse]="video">
            <iframe  [src]="src | safe: 'resourceUrl'" frameborder="0" allow="autoplay;" webkitallowfullscreen
               mozallowfullscreen allowfullscreen>
            </iframe>
         </ng-template>
         
         <!-- Video -->
         <ng-template #video>
            <video *ngIf="config.autoplay" controls autoplay>
               <source [src]="src | safe: 'resourceUrl'" type="video/webm">
               <source [src]="src | safe: 'resourceUrl'" type="video/mp4">
               <source [src]="src | safe: 'resourceUrl'" type="video/ogg">
               <source [src]="src | safe: 'resourceUrl'" type="video/3gp">
               <source [src]="src | safe: 'resourceUrl'" type="video/quicktime">
               <source [src]="src | safe: 'resourceUrl'" type="video/x-quicktime">
               <source [src]="src | safe: 'resourceUrl'" type="video/avi">
               <source [src]="src | safe: 'resourceUrl'" type="video/x-ms-wmv">
               <source [src]="src | safe: 'resourceUrl'" type="video/x-ms-asf">
               Sorry, your browser doesn't support embedded videos.
            </video>
            <video *ngIf="!config.autoplay" controls>
               <source [src]="src | safe: 'resourceUrl'" type="video/webm">
               <source [src]="src | safe: 'resourceUrl'" type="video/mp4">
               <source [src]="src | safe: 'resourceUrl'" type="video/ogg">
               <source [src]="src | safe: 'resourceUrl'" type="video/3gp">
               <source [src]="src | safe: 'resourceUrl'" type="video/quicktime">
               <source [src]="src | safe: 'resourceUrl'" type="video/x-quicktime">
               <source [src]="src | safe: 'resourceUrl'" type="video/avi">
               <source [src]="src | safe: 'resourceUrl'" type="video/x-ms-wmv">
               <source [src]="src | safe: 'resourceUrl'" type="video/x-ms-asf">
               Sorry, your browser doesn't support embedded videos.
            </video>
         </ng-template>
       

      </div>
   </div>

</ng-template>